import React from 'react';
import ActionCardContractIcon from '../../../../../components/icons/ActionCardContractIcon';
import { ChoosePlanTemplateIcon } from '../../../../../components/icons/ChoosePlanTemplateIcon';
import { PlanTemplateIcon } from '../../../../../components/icons/PlanTemplateIcon';
import type { PlanCreationOption } from '../types/plan-creation-option';

export type PlanCreationOptionConfig = {
  value: PlanCreationOption;
  title: string;
  description: string;
  icon: React.ReactNode;
  iconBackground: string;
  disabled: boolean;
};

export const PLAN_CREATION_OPTIONS: readonly PlanCreationOptionConfig[] = [
  {
    value: 'new-contract',
    title: 'Start a new contract',
    description: 'Create a custom pricing plan for your customer',
    icon: <ActionCardContractIcon />,
    iconBackground: '#B0D2FF',
    disabled: false,
  },
  {
    value: 'new-template',
    title: 'Create a new template',
    description: 'Build a reusable pricing plan, add products and fees',
    icon: <PlanTemplateIcon />,
    iconBackground: '#E2DBFE',
    disabled: false,
  },
  {
    value: 'choose-template',
    title: 'Choose a template',
    description: 'Select an existing contract template to get started quickly',
    icon: <ChoosePlanTemplateIcon />,
    iconBackground: '#FFE0B0',
    disabled: false,
  },
] as const;
